export default __webpack_public_path__ + "static/media/tutorial.d3a3369e.png";